import { useState } from "react";
import { Flag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ReportUserDialog, type ReportContext } from "@/components/ReportUserDialog";

interface Props {
  messageId: string;
  messageText: string;
  senderId: string;
  senderName: string;
  context: ReportContext;
  contextId?: string;
  className?: string;
}

/** Small "Report" flag shown on other people's chat messages. */
export function ReportMessageButton({
  messageId,
  messageText,
  senderId,
  senderName,
  context,
  contextId,
  className = "",
}: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        size="sm"
        variant="ghost"
        className={`h-6 px-1.5 text-[10px] text-muted-foreground hover:text-destructive ${className}`}
        onClick={() => setOpen(true)}
        aria-label={`Report message from ${senderName}`}
      >
        <Flag className="h-2.5 w-2.5 mr-0.5" />
        Report
      </Button>
      {open && (
        <ReportUserDialog
          open={open}
          onOpenChange={setOpen}
          reportedUserId={senderId}
          reportedUserName={senderName}
          context={context}
          messageId={messageId}
          messageText={messageText}
          contextId={contextId}
        />
      )}
    </>
  );
}
